/** @jsx jsx */
import { SvgIcon, TypeApplicationIcon } from "@eworkit/iris";
import { FC, memo, useCallback } from "react";
import { jsx } from "theme-ui";

import { Text } from "@/components/Text";
import { Flex, Switch, TStyleBoolOrSize } from "@/eworkitComponents";

import "./_email-notification-setting.scss";

export interface IEmailNotificationSettingProps {
  name?: string;
  isChecked?: boolean;
  disabled?: boolean;
  indentation?: TStyleBoolOrSize;
  icon?: typeof SvgIcon;
  onChange?: (value?: boolean) => void;
}

export const EmailNotificationSetting: FC<IEmailNotificationSettingProps> = memo(
  ({ name, isChecked, disabled, indentation = false, icon = TypeApplicationIcon, onChange, children }) => {
    const baseClass = "email-notification-setting";
    const IconComponent = icon;

    const handleChange = useCallback(
      (value?: boolean) => {
        if (onChange) {
          onChange(value);
        }
      },
      [onChange],
    );

    return (
      <Flex className={baseClass} direction="row" margin={[false, false, false, indentation]}>
        <Flex direction="row" align="center" width={12}>
          <IconComponent size="md" color="n700" sx={{ marginRight: "xs" }} />

          {name ? (
            <Text size="md" color="black">
              {name}
            </Text>
          ) : (
            children
          )}

          <Flex justify="flex-end" direction="row" grow={1}>
            <Switch value={isChecked} disabled={disabled} onChange={handleChange} />
          </Flex>
        </Flex>
      </Flex>
    );
  },
);
